export default "__VITE_ASSET__BCDvxTnV__"